<div class="py-4 container-fluid disb-plan-page">
  <h4 class="mb-4 disb-plan-title">ตั้งค่าการส่งเบิก</h4>

  <div class="disb-plan-card">
    <div class="disb-plan-card-body">
      <h6 class="disb-plan-section-heading">วันที่ส่งเบิก (ใช้ร่วมกันทั้งคณะ)</h6>
      <p class="disb-plan-section-caption">
        กำหนดวันเริ่มต้นและวันสิ้นสุดการส่งเบิกสำหรับแต่ละเทอมการศึกษา โดยใช้ช่วงเวลาเดียวกันทุกสาขาวิชา ระบบจะตรวจสอบเงื่อนไขและส่งเบิกให้อาจารย์ที่ผ่านเงื่อนไขโดยอัตโนมัติเมื่อถึงวันเริ่มส่งเบิก
      </p>

      <div class="disb-plan-term-form" [formGroup]="termForm">
        <div class="disb-plan-filter">
          <app-select
            label="เทอมการศึกษา"
            formControlName="academicTerm"
            [options]="academicTermNameOptions"
            [clearable]="false"
            [searchable]="false"
            inputClass="ng-select-size-md"
            classes="mb-0"
          ></app-select>
        </div>

        <div class="disb-plan-filter">
          <app-select
            label="ปีการศึกษา"
            formControlName="academicYear"
            [options]="academicYearOptions"
            [clearable]="false"
            [searchable]="false"
            inputClass="ng-select-size-md"
            classes="mb-0"
          ></app-select>
        </div>

        <div class="disb-plan-filter">
          <app-datepicker
            label="วันที่ส่งเบิก"
            formControlName="disbursementDate"
            [required]="true"
            [clearable]="true"
            [minDate]="minDisbursementDate"
            [error]="termForm.controls.disbursementDate.invalid && termForm.controls.disbursementDate.touched ? termForm.controls.disbursementDate.errors : null"
            [errorMessage]="termDateErrorMessage('disbursementDate')"
            inputClass="app-input-size-md"
            classes="mb-0"
          ></app-datepicker>
        </div>

        <div class="disb-plan-filter disb-plan-filter--with-hint">
          <app-datepicker
            label="วันเริ่มรอบเก็บตก"
            formControlName="catchUpDate"
            [clearable]="true"
            [error]="termForm.controls.catchUpDate.invalid && termForm.controls.catchUpDate.touched ? termForm.controls.catchUpDate.errors : null"
            [errorMessage]="termDateErrorMessage('catchUpDate')"
            inputClass="app-input-size-md"
            classes="mb-0"
          ></app-datepicker>
          <span
            class="disb-plan-field-hint"
            tabindex="0"
            role="button"
            aria-label="ต้องเป็นวันหลังวันที่ส่งเบิกอย่างน้อย 14 วัน — รอบเก็บตกเปิดสิทธิ์ส่งกลับแก้ไขต่ออีก 14 วัน หลังหมดรอบแรก (ไม่เพิ่มรายชื่อผู้ส่งเบิก)"
          >
            <i class="bi bi-info-circle disb-plan-field-hint-icon" aria-hidden="true"></i>
            <span class="disb-plan-field-hint-bubble" role="tooltip">
              ต้องเป็นวันหลังวันที่ส่งเบิกอย่างน้อย 14 วัน — รอบเก็บตกเปิดสิทธิ์ส่งกลับแก้ไขต่ออีก 14 วัน หลังหมดรอบแรก (ไม่เพิ่มรายชื่อผู้ส่งเบิก)
            </span>
          </span>
        </div>

        <div class="disb-plan-filter">
          <app-datepicker
            label="วันที่สิ้นสุดการส่งเบิก"
            formControlName="endDate"
            [required]="true"
            [clearable]="true"
            [error]="termForm.controls.endDate.invalid && termForm.controls.endDate.touched ? termForm.controls.endDate.errors : null"
            [errorMessage]="termDateErrorMessage('endDate')"
            inputClass="app-input-size-md"
            classes="mb-0"
          ></app-datepicker>
        </div>

        @if (termDateErrors(); as dateErrors) {
          @if (dateErrors.length > 0) {
            <div class="disb-plan-term-errors" role="alert">
              @for (item of dateErrors; track item.label) {
                <p class="disb-plan-term-error">{{ item.label }}: {{ item.message }}</p>
              }
            </div>
          }
        }

        <div class="disb-plan-term-footer">
          <button
            type="button"
            class="btn btn-primary disb-plan-save-button"
            [disabled]="termSettingLoading() || termSettingSaving() || termSettingClosed"
            (click)="onOpenTermSaveConfirm()"
          >
            {{ termSettingSaving() ? 'กำลังบันทึก...' : 'บันทึก' }}
          </button>
        </div>
      </div>

      @if (termSettingLocked) {
        <p class="disb-plan-hint-note">ถึงวันที่ส่งเบิกของเทอมนี้แล้ว — แก้ไขวันที่ส่งเบิกไม่ได้ (แก้วันเริ่มรอบเก็บตกและวันที่สิ้นสุดได้จนกว่าจะถึงวันนั้น)</p>
      }
      @if (catchUpLocked) {
        <p class="disb-plan-hint-note">ถึงวันเริ่มรอบเก็บตกแล้ว — แก้ไขวันเริ่มรอบเก็บตกไม่ได้</p>
      }
    </div>
  </div>

  <div class="disb-plan-card">
    <div class="disb-plan-card-body">
      <h6 class="disb-plan-section-heading">แผนงาน/โครงการ (ค่าตั้งต้นของทุกสาขาวิชา)</h6>
      <p class="disb-plan-section-caption">
        กำหนดเป็นค่าเริ่มต้นสำหรับทุกสาขาวิชา โดยระบบจะเติมค่าอัตโนมัติเมื่อกด “แก้ไข” ข้อมูลในแต่ละสาขาวิชา ทั้งนี้ ค่าจะมีผลกับสาขาวิชานั้นเมื่อกด “บันทึก” ข้อมูลในแต่ละสาขาวิชาเท่านั้น
      </p>

      <form class="disb-plan-default-form" [formGroup]="defaultForm">
        <app-input
          label="แผนงาน"
          formControlName="planName"
          inputClass="app-input-size-md"
          classes="mb-0"
        ></app-input>

        <app-input
          label="งาน/โครงการ"
          formControlName="projectName"
          inputClass="app-input-size-md"
          classes="mb-0"
        ></app-input>

        <app-input
          label="หมวดรายจ่าย"
          formControlName="expenseCategory"
          labelHint="ระบุชื่อหมวดรายจ่ายพร้อมรหัสในวงเล็บ เช่น ค่าตอบแทน (126830) โดยข้อมูลนี้จะเป็นข่อมูลตั้งต้นของแต่ละสาขาวิชาเท่านั้น และจะแสดงบนใบปะหน้าเมื่อบันทึกข้อมูลของสาขาวิชานั้นเรียบร้อยแล้ว"
          inputClass="app-input-size-md"
          classes="mb-0"
        ></app-input>

        <button
          type="button"
          class="btn btn-primary disb-plan-save-button"
          [disabled]="defaultSettingSaving()"
          (click)="onOpenDefaultSaveConfirm()"
        >
          {{ defaultSettingSaving() ? 'กำลังบันทึก...' : 'บันทึกค่าตั้งต้น' }}
        </button>
      </form>
    </div>
  </div>

  <div class="disb-plan-card">
    <div class="disb-plan-card-body">
      <h6 class="disb-plan-section-heading">แผนงาน/โครงการ และเจ้าหน้าที่การเงินประจำสาขาวิชา (ตามเทอมการศึกษาที่เลือกด้านบน)</h6>
      <p class="disb-plan-section-caption">
        ค่าที่แสดงเป็นค่าที่แต่ละสาขาวิชาบันทึกไว้ หากยังไม่ได้บันทึก ระบบจะแสดง “-” และจะไม่มีการนำค่าไปแสดงบนใบปะหน้า สามารถกด “แก้ไข” เพื่อกำหนดค่าของแต่ละสาขาวิชา โดยค่าเดียวกันนี้ใช้สำหรับทุกเทอมการศึกษา
      </p>

      @if (deptSettingsLocked()) {
        <p class="disb-plan-hint-note mb-3">เมื่อถึงวันส่งเบิกของเทอมการศึกษาปัจจุบัน สาขาวิชาที่บันทึกค่าไว้แล้วจะไม่สามารถแก้ไขได้ ส่วนสาขาวิชาที่ยังไม่เคยบันทึกค่ายังคงสามารถกำหนดค่าได้</p>
      }

      <ng-template #actionTemplate let-row="row">
        @if (!isRowLocked(row)) {
          <button
            type="button"
            class="btn disb-plan-action-button"
            aria-label="แก้ไขการตั้งค่าสาขาวิชา"
            title="แก้ไข"
            (click)="onOpenEditDialog(row)"
          >
            <img
              src="assets/media/icons/svg/pencxil.svg"
              class="disb-plan-action-icon"
              alt=""
              aria-hidden="true"
            />
          </button>
        }
      </ng-template>

      <app-datatable
        [datasource]="datasource()"
        [columns]="columns"
        [isLoading]="tableLoading()"
        [showFooter]="false"
        [limit]="50"
      ></app-datatable>

      <app-table-pagination
        [page]="datasource().page"
        [limit]="datasource().limit"
        [total]="datasource().total"
        [totalPage]="datasource().total_page"
        [offset]="datasource().offset"
        [dataLength]="datasource().data.length"
        ariaLabel="disbursement plan pagination"
        (pageChange)="onPageChange($event)"
        (limitChange)="onLimitChange($event)"
      ></app-table-pagination>
    </div>
  </div>
</div>

@if (editDialogOpen()) {
  <div class="disb-plan-modal-overlay" role="presentation">
    <div
      class="disb-plan-modal-panel"
      role="dialog"
      aria-modal="true"
      aria-labelledby="disbPlanEditTitle"
    >
      @if (editTarget(); as row) {
        <div class="disb-plan-detail-header">
          <div>
            <h5 id="disbPlanEditTitle">ตั้งค่าการส่งเบิกของสาขาวิชา</h5>
            <div class="disb-plan-detail-meta">
              <span>สาขาวิชา: {{ row.departmentName }}</span>
            </div>
          </div>
          <button type="button" class="btn-close" aria-label="ปิด" (click)="onCloseEditDialog()"></button>
        </div>

        <div class="disb-plan-detail-body">
          <p class="disb-plan-section-caption">
            เติมค่าตั้งต้นไว้ให้แล้ว แก้ไขได้ตามต้องการ — ต้องกรอกให้ครบทุกช่อง จะมีผลกับสาขานี้ใน
            เทอม {{ termForm.controls.academicTerm.value }}/{{ termForm.controls.academicYear.value }} เมื่อกดบันทึก
          </p>

          <form class="disb-plan-setting-form" [formGroup]="settingForm">
            <app-input
              label="แผนงาน"
              formControlName="planName"
              [required]="true"
              [error]="settingControlHasError('planName') ? settingForm.controls.planName.errors : null"
              [errorMessage]="settingErrorMessage('planName')"
              inputClass="app-input-size-md"
              classes="mb-0"
            ></app-input>

            <app-input
              label="งาน/โครงการ"
              formControlName="projectName"
              [required]="true"
              [error]="settingControlHasError('projectName') ? settingForm.controls.projectName.errors : null"
              [errorMessage]="settingErrorMessage('projectName')"
              inputClass="app-input-size-md"
              classes="mb-0"
            ></app-input>

            <app-input
              label="หมวดรายจ่าย"
              formControlName="expenseCategory"
              labelHint="ระบุชื่อหมวดรายจ่ายพร้อมรหัสในวงเล็บ เช่น ค่าตอบแทน (126830) โดยข้อมูลนี้จะเป็นข่อมูลตั้งต้นของแต่ละสาขาวิชาเท่านั้น และจะแสดงบนใบปะหน้าเมื่อบันทึกข้อมูลของสาขาวิชานั้นเรียบร้อยแล้ว"
              [required]="true"
              [error]="settingControlHasError('expenseCategory') ? settingForm.controls.expenseCategory.errors : null"
              [errorMessage]="settingErrorMessage('expenseCategory')"
              inputClass="app-input-size-md"
              classes="mb-0"
            ></app-input>

            <app-select
              label="เจ้าหน้าที่การเงิน"
              formControlName="financeOfficerUserId"
              [options]="financeOfficers()"
              bindLabel="full_name"
              bindValue="id"
              placeholder="เลือกเจ้าหน้าที่การเงิน"
              [required]="true"
              [clearable]="false"
              [error]="settingControlHasError('financeOfficerUserId') ? settingForm.controls.financeOfficerUserId.errors : null"
              [errorMessage]="settingErrorMessage('financeOfficerUserId')"
              inputClass="ng-select-size-md"
              classes="mb-0"
            ></app-select>
          </form>
        </div>

        <div class="disb-plan-detail-footer">
          <button
            type="button"
            class="btn btn-secondary"
            [disabled]="settingSaving()"
            (click)="onCloseEditDialog()"
          >
            ยกเลิก
          </button>
          <button
            type="button"
            class="btn btn-primary"
            [disabled]="settingSaving() || isRowLocked(row) || settingForm.invalid"
            (click)="onOpenSettingSaveConfirm()"
          >
            {{ settingSaving() ? 'กำลังบันทึก...' : 'บันทึก' }}
          </button>
        </div>
      }
    </div>
  </div>
}

<app-confirm-dialog
  #termSaveConfirmDialog
  modalId="disbursementPlanTermSaveDialog"
  icon="warning"
  title="ยืนยันการบันทึกวันที่ส่งเบิก"
  [message]="termSaveConfirmMessage()"
  cancelText="ยกเลิก"
  confirmText="ยืนยัน"
  [isProcessing]="termSettingSaving()"
  (confirmed)="onSaveTermSetting()"
></app-confirm-dialog>

<app-confirm-dialog
  #defaultSaveConfirmDialog
  modalId="disbursementPlanDefaultSaveDialog"
  icon="success"
  title="ยืนยันการบันทึกค่าตั้งต้น"
  [message]="defaultSaveConfirmMessage"
  cancelText="ยกเลิก"
  confirmText="ยืนยัน"
  [isProcessing]="defaultSettingSaving()"
  (confirmed)="onSaveDefaultSetting()"
></app-confirm-dialog>

<app-confirm-dialog
  #settingSaveConfirmDialog
  modalId="disbursementPlanSettingSaveDialog"
  icon="success"
  title="ยืนยันการบันทึกค่าตั้งต้น"
  [message]="settingSaveConfirmMessage()"
  cancelText="ยกเลิก"
  confirmText="ยืนยัน"
  [isProcessing]="settingSaving()"
  [stackAboveModal]="true"
  (confirmed)="onSaveSetting()"
></app-confirm-dialog>

<app-confirm-dialog
  #actionSuccessDialog
  modalId="disbursementPlanSuccessDialog"
  icon="success"
  [title]="successTitle()"
  [message]="successMessage()"
  confirmText="ปิด"
  [showCancelButton]="false"
  [stackAboveModal]="true"
  (confirmed)="actionSuccessDialog.close()"
></app-confirm-dialog>
